<template>
    <v-app id="app_measurements">
        <v-overlay v-model="centerLoading" :scrim="false" class="custom_centered_overlay">
            <v-progress-circular color="#2A8200" indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-container fluid>
            <v-row>
                <v-col class="mt-0" cols="7">
                    <p class="custom_page_main_title">INDIVIDUAL CLIENT</p>
                    <p class="custom_page_main_sub_title" style="opacity: 0.6">
                        Analyse the individual client list using a variety of parameters.
                    </p>
                </v-col>
                <v-col class="px-4 mt-7" cols="5">
                    <v-row class="custom_tool_bar_style">
                        <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
                        <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute">
                            <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
            <v-card class="pa-5 mt-8">

                <v-card-text class="custom_tool_bar_style">
                    <div style="width: 200px;">
                        <v-btn class="custom_pdf_btn" variant="outlined" @click="ERPDialog = true">
                            <v-icon>mdi-sync</v-icon>&nbsp; FETCH DATA FROM ERP
                        </v-btn>
                    </div>
                    <v-btn class="custom_excel_btn" variant="outlined" @click="exportExcel">
                        <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
                    </v-btn>
                </v-card-text>


                <v-divider></v-divider>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-autocomplete v-model="selectedCategories" :items="categoryOptions"
                            append-inner-icon="mdi-close" item-title="Province" label="Province" multiple
                            variant="outlined" @change="fetchData" @click:append-inner="clearCategory"
                            density="comfortable" class="custom_input_field_color"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-autocomplete v-model="selectedCategories" :items="categoryOptions"
                            append-inner-icon="mdi-close" item-title="District" label="District" multiple
                            variant="outlined" @change="fetchData" @click:append-inner="clearCategory"
                            density="comfortable" class="custom_input_field_color"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-autocomplete v-model="selectedCategories" :items="categoryOptions"
                            append-inner-icon="mdi-close" item-title="Residence" label="Residence" multiple
                            variant="outlined" @change="fetchData" @click:append-inner="clearCategory"
                            density="comfortable" class="custom_input_field_color"></v-autocomplete>
                    </v-col>

                </v-row>

                <v-row>
                    <v-col cols="12" md="4">
                        <v-autocomplete v-model="selectedCategories" :items="categoryOptions"
                            append-inner-icon="mdi-close" item-title="Gender" label="Gender" multiple variant="outlined"
                            @change="fetchData" @click:append-inner="clearCategory" density="comfortable"
                            class="custom_input_field_color"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-autocomplete v-model="selectedCategories" :items="categoryOptions"
                            append-inner-icon="mdi-close" item-title="Sector" label="Sector" multiple variant="outlined"
                            @change="fetchData" @click:append-inner="clearCategory" density="comfortable"
                            class="custom_input_field_color"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field v-model="searchQuery" label="Search" variant="outlined"
                            prepend-inner-icon="mdi-magnify" density="comfortable" class="custom_input_field_color"
                            clearable></v-text-field>
                    </v-col>


                </v-row>





                <v-row>


                    <v-data-table v-model:page="page" :loading="loading" :headers="headers" :items="filteredItems"
                        :items-per-page="itemsPerPage" class="custom_table_normal" @update:page="page = $event"
                        @page-count="totalPages = $event">
                        <!-- Custom Styling for DAY column -->
                        <!-- <template v-slot:[`item.day`]="{ item }">
                            <span style="color: #1976d2; font-weight: bold;">{{ item.day }}</span>
                        </template> -->



                        <!-- VIEW Button -->
                        <template v-slot:[`item.actions`]="{ }">
                            <v-btn style="
                                        width: 70% !important;
                                        background-color: #c1cdf3  !important;
                                        border: 1px solid #0e41ed  !important;
                                        color: #0e41ed  !important;
                                    " variant="outlined" @click="view_dialog = true">
                                VIEW
                            </v-btn>
                        </template>
                    </v-data-table>



                </v-row>


                <v-dialog v-model="ERPDialog" id="app_my_route_tracking" max-height="500" max-width="500" persistent>
                    <v-card rounded="md">
                        <div class="pa-4">
                            <v-card color="#F0F0F0" flat>
                                <template v-slot:prepend>
                                    <v-card-title class="text-subtitle-1 font-weight-bold">FETCH DATA FROM ERP
                                        SYSTEM</v-card-title>
                                </template>
                                <v-spacer></v-spacer>
                                <template v-slot:append>
                                    <v-btn @click="ERPDialog = false" icon="mdi-close" size="x-small"></v-btn>
                                </template>
                            </v-card>

                            <v-card color="white" flat class="mt-3">
                                <v-card-item>
                                    <v-card-title class="text-body-1 font-weight-medium">
                                        <v-icon color="warning" size="small">mdi-alert</v-icon>
                                        &nbsp;&nbsp;Do you want to fetch data from ERP system ?
                                    </v-card-title>

                                    <p style="opacity: 0.7" class="text-body-2 mt-4 text-justify">
                                        This will require data to be retrieved from your ERP system.
                                        <span>
                                            Do you agree to do that?
                                        </span>
                                    </p>

                                    <v-divider class="mt-4"></v-divider>

                                    <div class="float-end mt-4 ">
                                        <v-btn
                                            style="width: 35%; background-color: #002F87 !important; color: #FFFFFF !important;"
                                            variant="outlined" @click="delete_TIMEMANAGE_dialog = true">
                                           YES
                                        </v-btn>

                                        <v-btn class="ml-3 custom_btn_secondary"
                                            @click="ERPDialog = false">CANCEL</v-btn>
                                    </div>
                                </v-card-item>
                            </v-card>
                        </div>
                    </v-card>
                </v-dialog>





                <v-dialog v-model="view_dialog" fullscreen id="app_product_list">
                    <v-card flat>
                        <v-toolbar class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
                            <v-toolbar-title>
                                <v-img class="custom_company_logo_nav"
                                    :src="require('@/img/company_logo/Assetline_logo.png')"
                                    @click="homeReload()"></v-img>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn class="custom_red_btn" variant="flat" @click="view_dialog = false">CLOSE</v-btn>
                        </v-toolbar>

                        <v-row class="mt-15 custom_scroll_option_fullscreen_dialog">
                            <v-col cols="12">
                                <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1">
                                    <template v-slot:prepend>
                                        <v-icon>mdi-view-dashboard</v-icon>
                                        <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">CLIENT
                                            DETAILS</v-card-title>
                                    </template>
                                </v-card>



                               



                                <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1">


                                    <v-col cols="12" xs="12" sm="9" md="9" lg="9">
                                        <v-row>
                                            <v-col cols="12" xs="12" sm="3" md="2" lg="2">
                                                <v-img src="https://static.vecteezy.com/system/resources/thumbnails/000/439/863/small/Basic_Ui__28186_29.jpg" aspect-ratio="1"
                                                    class="user_image_view"></v-img>
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="9" md="10" lg="10">
                                                <div class="d-flex">
                                                    <p
                                                        class="font-weight-bold custom_page_component_main_title text-body-1">
                                                        Client Name: &nbsp;</p>
                                                    <p class="font-weight-bold custom_page_component_main_title"
                                                        style="color: #3d65e6 !important;">
                                                       ACC </p> <!-- Hardcoded Full Name -->
                                                </div>

                                                <div class="d-flex mt-1">
                                                    <p
                                                        class="font-weight-bold custom_page_component_main_title text-body-1">
                                                        Mobile Number: &nbsp;</p>
                                                    <p
                                                        class="font-weight-medium text-body-2 custom_page_component_main_title mt-1">
                                                        +1 234 567 8901, +1 987 654 3210</p>
                                                    <!-- Hardcoded Mobile Numbers -->
                                                </div>

                                                <div class="d-flex mt-6">
                                                    <v-chip class="text-body-1 mr-3 custom_green_chip"
                                                        variant="outlined">
                                                        <v-icon color="#1B5E20">mdi-check-circle-outline</v-icon>&nbsp;
                                                         TYPE - &nbsp;<span
                                                            style="text-transform: uppercase !important;">INDIVIDUAL CUSTOMER</span>
                                                        <!-- Hardcoded User Type -->
                                                    </v-chip>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-col>




                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="Display_Name" label="Surname" readonly
                                                variant="outlined" density="comfortable"
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="Premise_Code" label="Correspondence Address" readonly
                                                variant="outlined" density="comfortable"
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                item-title="Initials" label="Initials" multiple
                                                variant="outlined"
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                item-title="Latitude" label="Latitude" multiple
                                                variant="outlined"
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="Initial in full without surname"
                                                label="Initial in full without surname" multiple variant="outlined"
                                                density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="Longitude"
                                                label="Longitude" multiple variant="outlined"
                                                density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                item-title="Client Type"
                                                label="Client Type" multiple variant="outlined"
                                                density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="Residence"
                                                label="Residence" multiple variant="outlined"
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                item-title="Title"
                                                label="Title" multiple variant="outlined"
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="Home Telephone No" label="Home Telephone No"
                                                multiple variant="outlined" 
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="NIC"
                                                label="NIC" multiple variant="outlined"
                                                density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                item-title="Income Tax By"
                                                label="Income Tax By" multiple variant="outlined"
                                                density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                item-title="Preferred Language"
                                                label="Preferred Language" multiple variant="outlined"
                                                density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                item-title="Introduced By"
                                                label="Introduced By" multiple variant="outlined"
                                                density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="Marital Status"
                                                label="Marital Status" multiple variant="outlined" @change="fetchData"
                                                @click:append-inner="clearCategory" density="comfortable"
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                item-title="Source of Income"
                                                label="Source of Income" multiple variant="outlined"
                                                density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="Date of Birth"
                                                label="Date of Birth" multiple variant="outlined" 
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                item-title="Employment Status Code"
                                                label="Employment Status Code" multiple variant="outlined"
                                                density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="Gender"
                                                label="Gender" multiple variant="outlined" @change="fetchData"
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="Country Risk Factor"
                                                label="Country Risk Factor" multiple variant="outlined"
                                                density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="Nationality"
                                                label="Nationality" multiple variant="outlined"
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                item-title="Mode of Payment"
                                                label="Mode of Payment" multiple variant="outlined" 
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="Sector" label="Sector" multiple
                                                variant="outlined" @change="fetchData"
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="Geographical Risk Factor"
                                                label="Geographical Risk Factor" multiple variant="outlined"
                                                density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="Address Line 1" label="Address Line 1"
                                                multiple variant="outlined" @change="fetchData"
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                item-title="Source of Fund"
                                                label="Source of Fund" multiple variant="outlined" 
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="Town" label="Town"
                                                multiple variant="outlined" @change="fetchData"
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                item-title="Anticipated Volume Per Month"
                                                label="Anticipated Volume Per Month" multiple variant="outlined" 
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="District" label="District"
                                                multiple variant="outlined" @change="fetchData"
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                item-title="Delivery Channel Risk Factor"
                                                label="Delivery Channel Risk Factor" multiple variant="outlined" 
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                 item-title="Province" label="Province"
                                                multiple variant="outlined" @change="fetchData"
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="selectedCategories" :items="categoryOptions"
                                                item-title="Source of Income"
                                                label="Source of Income" multiple variant="outlined" 
                                                class="px-3 custom_input_field_class_view custom_input_field_color"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <v-textarea v-model="ERPDetails" class="px-3 custom_input_field_class_view custom_input_field_color" label="PEP Details with Remarks" rows="2"
                                                variant="outlined" color="#BB0000"></v-textarea>
                                        </v-col>
                                    </v-row>


                                    

                                    




                                </v-card>






                            </v-col>
                        </v-row>
                    </v-card>
                </v-dialog>

            </v-card>
        </v-container>
    </v-app>
</template>

<script>
export default {
    data() {
        return {


            view_dialog: false,
            ERPDialog: false,
            userPermissions: ['delete'], // Example permissions

            page: 1,
            loading: false,
            itemsPerPage: 10,
            headers: [
                { text: "CLIENT NIC", value: "CLIENT_NIC", sortable: true, title: "CLIENT NIC" },
                { text: "CLIENT FULL NAME", value: "CLIENT_FULL_NAME", sortable: true, title: "CLIENT FULL NAME" },
                {
                    text: "PROVINCE",
                    value: "PROVINCE",
                    sortable: true,
                    title: "PROVINCE",
                },
                {
                    text: "DISTRICT",
                    value: "DISTRICT",
                    sortable: true,
                    title: "DISTRICT",
                },
                
                { text: "CLIENT ADDRESS", value: "CLIENT_ADDRESS", sortable: true, title: "CLIENT ADDRESS" },

                { text: "ACTION", value: "actions", sortable: false, title: "ACTION" },
            ],
            filteredItems: [
                {
                    CLIENT_NIC: "20014090897",
                    CLIENT_FULL_NAME: "L.P.F.Perera",
                    PROVINCE: "Western",
                    DISTRICT: "Colombo",
                    CLIENT_ADDRESS: "NO:284/4,Bandaranayake rd, Moratuwa",


                },
                {
                    CLIENT_NIC: "200234567890",
                    CLIENT_FULL_NAME: "W.R.Y.Fernando",
                    PROVINCE: "Western",
                    DISTRICT: "Kaluthara",
                    CLIENT_ADDRESS: "NO:345/3,New Rd,Kaluthara.",

                },
            ],
        };
    },
    methods: {
        hasPermission(permission) {
            return this.userPermissions.includes(permission);
        },
    },
};
</script>

<style scoped>
.custom_card_box {
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
}

.user_image_view {
    width: 70px;
    height: 70px;
    border-radius: 70%;
}

.custom_green_chip {
    background-color: #e8f5e9;
    color: #1B5E20;
    font-weight: bold;
}
</style>
